/* =====================================================
   NuFace 2026 Redesign — Announcement Bar JS
   MS 2026-05-19

   Lightweight rotator. No deps. One IIFE per page.
   ===================================================== */
(function () {
  'use strict';

  var roots = document.querySelectorAll('.announcement-bar-2026');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var slides = root.querySelectorAll('.announcement-bar-2026__slide');
    if (slides.length < 2) {
      if (slides[0]) slides[0].setAttribute('data-active', 'true');
      return;
    }

    var prev = root.querySelector('.announcement-bar-2026__arrow--prev');
    var next = root.querySelector('.announcement-bar-2026__arrow--next');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-autoplay-length'), 10) || 5;
    var current = 0;
    var timer = null;

    function show(i) {
      slides.forEach(function (s, idx) {
        s.setAttribute('data-active', idx === i ? 'true' : 'false');
      });
      current = i;
    }

    function go(delta) {
      var n = slides.length;
      show(((current + delta) % n + n) % n);
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { go(1); }, interval * 1000);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    if (next) next.addEventListener('click', function () { go(1);  start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    show(0);
    start();
  });
})();
